import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../css/AppointmentFilterComponent.css";

const filterOptions = [
  { id: "newAppointments", label: "New Appointments" },
  { id: "upcomingAppointments", label: "Upcoming Appointments" },
  { id: "completedAppointments", label: "Completed Appointments" },
  { id: "clinicVisit", label: "Clinic Visit" },
  { id: "homeVisit", label: "Home Visit" },
  { id: "onlineConsultation", label: "Online Consultation" },
];

const dropdownVariants = {
  hidden: {
    opacity: 0,
    y: -10,
    scaleY: 0.8,
    transformOrigin: "top",
    transition: { duration: 0.2, ease: "easeInOut" },
  },
  visible: {
    opacity: 1,
    y: 0,
    scaleY: 1,
    transformOrigin: "top",
    transition: { duration: 0.3, ease: "easeOut" },
  },
  exit: {
    opacity: 0,
    y: -10,
    scaleY: 0.8,
    transformOrigin: "top",
    transition: { duration: 0.2, ease: "easeIn" },
  },
};


const AppointmentFilterComponent = ({ showFilters, filters, onFilterChange }) => {
  const handleCheckboxChange = (event) => {
    const { id, checked } = event.target;
    onFilterChange(id, checked);
  };

  return (
    <div className="appointment-filter-container">
      <AnimatePresence>
        {showFilters && (
          <motion.div
            id="appointment-filter-dropdown"
            className="appointment-filter-dropdown"
            variants={dropdownVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            {filterOptions.map((filter) => (
              <div key={filter.id} className="appointment-filter-card">
                <label className="appointment-filter-label" htmlFor={filter.id}>
                  <span>{filter.label}</span>
                </label>
                <input
                  type="checkbox"
                  className="appointment-filter-checkbox"
                  id={filter.id}
                  checked={filters[filter.id] || false}
                  onChange={handleCheckboxChange}
                />
              </div>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default AppointmentFilterComponent;
